import { render, staticRenderFns } from "./teamFitRefSaved.vue?vue&type=template&id=f8f532ce&scoped=true&"
import script from "./teamFitRefSaved.vue?vue&type=script&lang=js&"
export * from "./teamFitRefSaved.vue?vue&type=script&lang=js&"
import style0 from "./teamFitRefSaved.vue?vue&type=style&index=0&id=f8f532ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f532ce",
  null
  
)

export default component.exports